import { render, staticRenderFns } from "./PracticeCoding.vue?vue&type=template&id=44b989c6&scoped=true&v-bind=%24props"
import script from "./PracticeCoding.vue?vue&type=script&lang=js"
export * from "./PracticeCoding.vue?vue&type=script&lang=js"
import style0 from "./PracticeCoding.vue?vue&type=style&index=0&id=44b989c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b989c6",
  null
  
)

export default component.exports